export default "__VITE_PUBLIC_ASSET__b7276292__"